<template>
  <div class="allCampaign">
    <div class="container-router">
      <div class="title">
        <h1 class="medium-title">Campaign Monitoring</h1>
        <ul class="title__menu">
          <router-link tag="li" :to="{name: 'monitoringcampaign'}">Static Advertising</router-link>
          <router-link tag="li" :to="{name: 'monitoringbuscampaign'}">Transit Advertising</router-link>
        </ul>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
import TransactionItem from '@/views/Transaction/TransactionItem'
import SideBar from '@/components/SideBar/Desktop'
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-',
  components: {
    'transaction-item': TransactionItem,
    "adx-sidebar": SideBar,
    'adx-loading': Loading,
    'adx-pagination': Pagination
  },
  props: {

  },
  data() {
    return {
      items: [],
      isLoading: false,
      currentPage: 1,
      maxPage: 1
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    const { page } = this.$route.query
    if(page){
      this.currentPage = parseInt(page)
    }
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
